import { defineMessages } from "react-intl";

const baseId = "t.components.sidebarUserInfo.";

export default defineMessages({
  firstName: {
    id: baseId + "name",
    defaultMessage: "name",
  },
  lastName: {
    id: baseId + "lastName",
    defaultMessage: "Surname",
  },
  userId: {
    id: baseId + "userId",
    defaultMessage: "User id",
  },
  office: {
    id: baseId + "office",
    defaultMessage: "Office",
  },
});
